import { getLocalStorage, saveLocalStorage } from "@elit-hair/elit-tools";

const QUALITY_WATCH_CACHE_KEY = "v1-qualityWatchQueryCache";

/**
 * Get persisted Quality Watch query cache from localStorage
 */
export function getPersistedQualityWatchCache(): Record<string, unknown> {
    return getLocalStorage<Record<string, unknown>>(QUALITY_WATCH_CACHE_KEY, {});
}

/**
 * Save Quality Watch query cache to localStorage
 */
export function savePersistedQualityWatchCache(cache: Record<string, unknown>): void {
    try {
        saveLocalStorage(QUALITY_WATCH_CACHE_KEY, cache);
    } catch (error) {
        // Handle quota exceeded errors gracefully
        if (error instanceof Error && error.name === "QuotaExceededError") {
            console.warn("localStorage quota exceeded. Clearing old Quality Watch cache entries.");
            // Clear cache if storage is full
            saveLocalStorage(QUALITY_WATCH_CACHE_KEY, {});
        }
    }
}

/**
 * Check if a query key is a Quality Watch query
 */
export function isQualityWatchQuery(queryKey: unknown): boolean {
    return Array.isArray(queryKey) && queryKey[0] === "user-average-dimension-view";
}

/**
 * Serialize query data for storage
 */
export function serializeQueryData(data: unknown): unknown {
    try {
        // Use JSON to ensure data is serializable
        return JSON.parse(JSON.stringify(data));
    } catch {
        return null;
    }
}
